'use strict';

import React from 'react';

import classNames from 'classnames';

import 'styles/PopoverIcon.scss';


const propTypes = {};

const defaultProps = {};

class PopoverIcon extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const className = classNames(
            'popover-icon', this.props.className
        );

        return (
            <span className={className}><i className="icon-information-text" /></span>
        );
    }
}

PopoverIcon.propTypes = propTypes;
PopoverIcon.defaultProps = defaultProps;
export default PopoverIcon;
